var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElCard',{ref:"hot",staticClass:"hot-user"},[_c('div',{staticClass:"title"},[_vm._v("近期活跃客户")]),_c('section',{ref:"main",staticClass:"hot-echarts"})])}
var staticRenderFns = []

export { render, staticRenderFns }